import { Controller } from 'react-hook-form';
import Checkbox from '../../checkbox/checkbox';
import { DisableCreationOptionTypes } from './types';

import cn from './styles.module.css';

export default function DisableCreationOption({
  control,
  clearErrors,
  withMargin,
}: DisableCreationOptionTypes) {
  return (
    <div
      className={`${cn.disableCreationOptionWrapper} ${withMargin ? cn.withMargin : ''}`}
    >
      <Controller
        name="disableExternalTransactionCreate"
        control={control}
        render={({ field: { name, value, onChange } }) => (
          <Checkbox
            name={name}
            type="checkbox"
            title="Already executed on Partner Bank side"
            checked={value}
            onChange={(e) => {
              onChange(e.target.checked);
              if (clearErrors) {
                clearErrors(['disableExternalTransactionCreate']);
              }
            }}
          />
        )}
      />
      <div className={cn.disableCreationOptionText}>
        The transaction won&apos;t be sent to the Partner Bank via API.
        <br />
        Use it to record a transaction that has already been executed on the
        Partner Bank side.
      </div>
    </div>
  );
}
